import { render, staticRenderFns } from "./Holdback.vue?vue&type=template&id=2d9a2dce"
import script from "./Holdback.vue?vue&type=script&lang=js"
export * from "./Holdback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports